export default __webpack_public_path__ + "static/media/comunicado.177e0e62.svg";